import { FunctionComponent } from 'preact';
import { useSelector, useDispatch } from 'react-redux';
import {
  playNextVideo,
  replayVideo,
} from '../store/discoveryPlugin.actions';
import { mediaDataSelector } from '../../../common/store/selectors/mediaData.selector';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { NextVideoBigSize } from './nextVideoBigSize/nextVideoBigSize';
import { NextVideoSmallSize } from './nextVideoSmallSize/nextVideoSmallSize';
import { moreVideosSelector } from '../../../common/store/selectors/moreVideos.selector';

interface NextVideoComponentVariablesProps {
  setIsClosedUpNext?: (isClosedUpNext: boolean) => void;
  countdownTime: number;
}

export const NextVideo: FunctionComponent<NextVideoComponentVariablesProps> = props => {
  const {
    setIsClosedUpNext,
    countdownTime,
  } = props;

  const dispatch = useDispatch();
  const videoList = useSelector(mediaDataSelector.videoList);
  const playerSize = useSelector(playerDataSelector.playerSize);
  const videoTagStatus = useSelector(playerDataSelector.videoTagStatus);
  const galleryView = useSelector(moreVideosSelector.galleryView);

  const isSingleVideo = videoList.length === 1;
  const playerSizeWithSmallComponent = playerSize === 'medium' || (playerSize === 'large' && galleryView);
  const smallNextVideoComponent = playerSizeWithSmallComponent && videoTagStatus !== 'complete';

  const onClickNextVideo = (): void => {
    if (isSingleVideo) {
      dispatch(replayVideo());
    } else {
      dispatch(playNextVideo());
    }
  };

  return (
    smallNextVideoComponent
      ? (
        <NextVideoSmallSize
          onClickNextVideo={onClickNextVideo}
          countdownTime={countdownTime}
        />
      )
      : (
        <NextVideoBigSize
          setIsClosedUpNext={setIsClosedUpNext}
          onClickNextVideo={onClickNextVideo}
          countdownTime={countdownTime}
        />
      )
  );
};
